import { Link, NavigationContainer } from "@react-navigation/native";
import { createStackNavigator } from "@react-navigation/stack";
import { useFonts } from "expo-font";
import { StatusBar } from "expo-status-bar";
import { Image, StyleSheet, Text, View } from "react-native";
import Landing from "./src/components/Landing";

import Privacy from "./src/components/Privacy";

const Stack = createStackNavigator();

export default function App() {
  return (
    <NavigationContainer>
      <Stack.Navigator
        screenOptions={{ headerShown: false }}
        initialRouteName="Home"
      >
        <Stack.Screen component={Home} name="Home" />
        <Stack.Screen component={Privacy} name="Privacy" />
      </Stack.Navigator>
    </NavigationContainer>
  );
}

const Home = () => {
  return (
    <View style={{ flex: 1, backgroundColor: "#1DB954" }}>
      <NavBar />
      <View style={styles.container}>
        <Landing />
      </View>
    </View>
  );
};

const NavBar = () => {
  let [fontsLoaded] = useFonts({
    RobotoMedium: require("./src/assets/fonts/Roboto-Medium.ttf"),
    GothamMedium: require("./src/assets/fonts/GothamMedium.ttf"),
  });
  return (
    <View
      style={{
        height: "30",
        flexDirection: "row",
        justifyContent: "space-between",
        marginHorizontal: 20,
        padding: 10,
      }}
    >
      <View style={{ flex: 2, flexDirection: "row", alignItems: "center" }}>
        <Image
          source={require("./src/assets/homeLogo.png")}
          style={{ height: 40, width: 40, marginHorizontal: 10 }}
        />
      </View>
      <View style={{ flex: 1, justifyContent: "center" }}>
        <Link
          to={{ screen: "Privacy" }}
          style={{ fontFamily: "GothamMedium", color: "white" }}
        >
          Privacy Policy
        </Link>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    margin: 6,
  },
});
